export default function Check({ fill = "#0179F7" }) {
    return (
        <svg width="18" height="15" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.66681 6.39067L1.47148 4.19533L0.528809 5.138L3.66681 8.276L10.1381 1.80467L9.19547 0.862L3.66681 6.39067Z" fill={fill}/>
        </svg>
    );
}